import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Workspace from "./pages/Workspace";
import MeetingRooms from "./pages/MeetingRooms";
import Insights from "./pages/Insights";
import Reports from "./pages/Reports";
import HowItWorks from "./pages/HowItWorks";
import Settings from "./pages/Settings";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/workspace" element={<Workspace />} />
            <Route path="/meeting-rooms" element={<MeetingRooms />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster richColors closeButton position="top-right" />
    </div>
  );
}

export default App;
